import React from "react";
import { useTranslation } from 'react-i18next';
import LangSwitcher from "../Assets/Language-switcher";
import { Outlet, Link } from "react-router-dom";
import "../styles/Header.scss"

const Header = (props) => {

    const { i18n } = useTranslation();



    return (
        <div>
                <LangSwitcher/>
            <Outlet />
        </div>


    );
}

export default Header;

